import { buildValidations, validator } from 'ember-cp-validations';
import { not, or } from '@ember/object/computed';
import Model, { attr } from '@ember-data/model';
import classic from 'ember-classic-decorator';

const Validations = buildValidations({
  address: [
    validator('presence', {
      presence: true,
      disabled: or('model.skipValidation', 'model.prospectiveClient'),
      ignoreBlank: true,
      messageKey: 'errors.emailRequired',
    }),
    validator('presence', {
      presence: true,
      disabled: not('model.prospectiveClient'),
      messageKey: 'errors.emailRequired',
    }),
    validator('format', {
      type: 'email',
      allowBlank: true,
      messageKey: 'errors.invalidEmail',
    }),
  ],
});

@classic
export default class EmailModel extends Model.extend(Validations) {
  @attr() address;

  prospectiveClient = false;
}
